const ORGANIZATION_SEARCH_PAGE_TABS = {
  mddapOrganization: {
    value: 'mddap-organizations',
    displayName: 'MDDAP Organizations'
  },
  vipOrganization: {
    value: 'vip-organizations',
    displayName: 'VIP Organizations'
  }
};

export default ORGANIZATION_SEARCH_PAGE_TABS;
